import { BottomSheetModal } from '@gorhom/bottom-sheet'
import { useCallback, useRef } from 'react'

import { FilterBottomSheet } from './FilterBottomSheet'

export const useFilterOffersBottomSheet = () => {
  const filterBottomSheetRef = useRef<BottomSheetModal>(null)
  const filterBottomSheetComponent = (
    <FilterBottomSheet filterBottomSheetRef={filterBottomSheetRef} />
  )

  const presentFilterBottomSheet = useCallback(() => {
    filterBottomSheetRef.current?.present?.()
  }, [])
  return {
    filterBottomSheetComponent,
    presentFilterBottomSheet,
  }
}
